<template>
  <v-app>
    <v-main>
      <!-- alert  -->
      <v-dialog v-model="showUpdateUI" max-width="290">
        <v-card>
          <v-card-title class="text-h5"> Une nouvelle version ! </v-card-title>
          <v-card-text>
            Mettez a jour pour benificier de toutes les ameliorations.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="showUpdateUI = false">
              plus tard
            </v-btn>
            <v-btn color="green darken-1" text @click="accept()">
              Accepter
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- alert  -->
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
// import { getAuth } from "firebase/auth";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
} from "firebase/firestore";
import { db } from "@/main.js";

export default {
  name: "App",
  components: {},
  data() {
    return {
      showUpdateUI: false,
    };
  },
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        // this.showUpdateUI = true;
        this.accept();
      });
    }
  },
  methods: {
    async accept() {
      // this.showUpdateUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
    async getCurrentUserSavedData(uid) {
      const citiesRef = collection(db, "users");
      const q = query(citiesRef, where("uid", "==", uid));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.docs.length < 1) {
        await this.createNewUser(uid);
        return "ko";
      } else {
        var doc = querySnapshot.docs[0];
        return doc.data();
      }
    },
    async createNewUser(uid) {
      var data = {
        groupe: "",
        prenom: "",
        su: false,
        uid: uid,
      };
      await setDoc(doc(db, "users", uid), data);
    },
  },
  beforeMount: function () {
    var vm = this;
    // vm.$store.state.user = user;
    // vm.$store.state.userFB = res;
    // // vm.$store.state.url = res.fichierUrl;
    // vm.$store.state.groupe = res.groupe;
    // vm.$store.state.userId = res.uid;
    // vm.$store.state.prenom = res.prenom;
    vm.$store.dispatch("getCommerciaux");
    vm.$store.dispatch("getClientsComptable");
    vm.$store.dispatch("getStatusClientComptable");
    vm.$store.dispatch("getSecteurActiviteSecure");
    vm.$store.dispatch("getEtat");
    vm.$store.dispatch("getOrigine");
    vm.$store.dispatch("getAvencement");
    vm.$store.dispatch("getProduitFamill");
    vm.$store.dispatch("getenquetSol");

    // vm.$store.dispatch("getProjects");
    // vm.$store.dispatch("getUsers");
    // var auth = getAuth();
    // var vm = this;
    // auth.onAuthStateChanged(async (user) => {
    //   // console.log(user);
    //   if (!user) {
    //     vm.$router.push("login");
    //   } else {
    //     // console.log(user.uid);
    //     var res = await vm.getCurrentUserSavedData(user.uid);
    //     // console.log(res);
    //     if (res !== "ko") {
    //       if (res.groupe == "" || res.uid == "" || res.prenom == "") {
    //         vm.$router.push("config");
    //       } else {
    //         vm.$store.state.user = user;
    //         vm.$store.state.userFB = res;
    //         // vm.$store.state.url = res.fichierUrl;
    //         vm.$store.state.groupe = res.groupe;
    //         vm.$store.state.userId = res.uid;
    //         vm.$store.state.prenom = res.prenom;
    //         vm.$store.dispatch("getData");
    //         vm.$store.dispatch("getTaches");
    //         vm.$store.dispatch("getProjects");
    //         vm.$store.dispatch("getUsers");
    //       }
    //     } else {
    //       vm.$router.push("config");
    //     }
    //   }
    // });
  },
};
</script>
